import { LDateTime } from '@app/components/date/LDateTime';
import { StationLink } from '@app/components/stations/StationLink';
import { FragmentLink } from '@app/modules/fragments/components/FragmentLink';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { socialExport } from '@mi-front/api-clients';
import { DateTimeStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { Box, Chip } from '@mui/material';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useIntl } from 'react-intl';

type Props = {
  platform: SocialPlatform;
};

export const PlatformUploaded = ({ platform }: Props) => {
  const { $t } = useIntl();
  const query = socialExport.useListByPlatformUploadStatus(platform.id);

  return (
    <Box mt={0}>
      <QueryView query={query}>
        {(data: socialExport.ListByPlatformUploadStatus200) => (
          <MrtTable
            data={data.results}
            columns={[
              {
                header: $t({
                  id: 'socialExport.uploaded.columnStation',
                  defaultMessage: 'Estación',
                }),
                accessorKey: 'stationId',
                Cell: ({ row }) =>
                  row.original.stationId && (
                    <StationLink
                      id={row.original.stationId}
                      link={`/fragments/s/${row.original.stationId}`}
                    />
                  ),
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnFragment',
                  defaultMessage: 'Fragmento',
                }),
                accessorKey: 'fragmentId',
                Cell: ({ row }) => {
                  const source = row.original.source as socialExport.FragmentSourceDto;
                  return <FragmentLink id={source.data.fragmentId} />;
                },
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnStatus',
                  defaultMessage: 'Estado',
                }),
                accessorKey: 'status',
                Cell: ({ row }) => (
                  <Chip
                    color={
                      row.original.status === socialExport.UploadDtoStatusEnum.COMPLETED
                        ? 'success'
                        : row.original.status === socialExport.UploadDtoStatusEnum.IN_PROGRESS
                          ? 'info'
                          : row.original.status === socialExport.UploadDtoStatusEnum.SCHEDULED
                            ? 'warning'
                            : 'error'
                    }
                    label={row.original.status}
                  />
                ),
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnPublished',
                  defaultMessage: 'Publicado',
                }),
                accessorKey: 'createdAt',
                Cell: ({ row }) => (
                  <LDateTime value={row.original.createdAt as DateTimeStr} showSeconds />
                ),
              },
            ]}
          />
        )}
      </QueryView>
    </Box>
  );
};
